export { getTestingPlaceholderData } from './get-testing-placeholder-data';
export { getTestingCoursePlaceholderData } from './get-testing-course-placeholder-data';

export type {
    TestingPlaceholderDataProps,
    TestingPlaceholderPayload,
} from './get-testing-placeholder-data';
export type {
    TestingCoursePlaceholderDataProps,
    TestingCoursePlaceholderPayload,
} from './get-testing-course-placeholder-data';
